import { useMemo } from 'react';

import { OrganizationTypes } from '@/common/constants';
import Permissions from '@/common/permissions';
import { useCurrentOrganization, useHasAccess } from '@/modules/core/hooks';
import { EmployerStatus } from '@/modules/employer/employer.constants.ts';

export const usePlanReactivationAccess = () => {
  const { observingOrganization } = useCurrentOrganization();

  const hasAccessReactivatePlan = useHasAccess([
    {
      permission: Permissions.ACTIVATE_PLAN,
    },
  ]);

  const isEmployerLevelOrganization = useMemo(() =>
    observingOrganization.type === OrganizationTypes.company
    || observingOrganization.type === OrganizationTypes.employer,
  [observingOrganization.type]);

  const isActiveEmployerLevelOrganization = useMemo(() =>
    isEmployerLevelOrganization
    && observingOrganization.status === EmployerStatus.Active,
  [isEmployerLevelOrganization, observingOrganization.status]);

  return {
    hasAccessReactivatePlan:
      hasAccessReactivatePlan && isActiveEmployerLevelOrganization,
  };
};
